import type { DataCollector } from 'owa-diagnostics-data-collection';
import { lazyRegisterDataCollectorIfNotRegistered } from 'owa-diagnostics-data-collection';
import loc from 'owa-localize';
import { copilotSettingsDiagDataCollectorDescription } from './registerDiagDataCollector.locstring.json';
import { getAllStoreDataForDiagnostics } from '../store/store';

export default async function registerDiagDataCollector(): Promise<void> {
    const summaryDataCollector: DataCollector = {
        dataCollectionAction: summaryDataCollectionAction,
        name: 'OutlookCopilotSettingsStore',
        odsFileDescription: 'Outlook Copilot settings data',
        description: loc(copilotSettingsDiagDataCollectorDescription),
    };

    await lazyRegisterDataCollectorIfNotRegistered.importAndExecute(summaryDataCollector);
}

function summaryDataCollectionAction(): Promise<string> {
    const diagInfo = {
        storeData: getAllStoreDataForDiagnostics(),
        threadSummarizationEnablementData: {
            itemViewEnabled: true,
        },
    };
    return Promise.resolve(JSON.stringify(diagInfo));
}
